import React from 'react';
import * as firebase from 'firebase';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import './stage-editor.css';

/** @class Size
  * Provides an interface for adjusting a stage's size.
  */
export default class Size extends ReactFireComponent {
  /** @constructor
    * Creates a new instance of Size
    * @prop {url} dataURL - the firebase reference url for the stage
    */
  constructor(props) {
    super(props);
    this.firebaseRef = firebase.database().ref(this.props.dataURL);
    this.state = {
      width: 1024,
      height: 768,
      scaleToFit: false
    }
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }
  /** @method componentWillMount
    * Binds the stage state to firebase
    */
  componentWillMount() {
    this.bindAsObject(this.props.dataURL + '/width', 'width');
    this.bindAsObject(this.props.dataURL + '/height', 'height');
    this.bindAsObject(this.props.dataURL + '/scaleToFit', 'scaleToFit');
  }
  /** @method componentWillUnmount
    * Unbinds the stage state from firebase.
    */
  componentWillUnmount() {
    this.unbind('width');
    this.unbind('height');
    this.unbind('scaleToFit')
  }
  /** @function handleChange
    * Updates the component state to reflect changes
    * in input fields.
    * @param {InputEvent} event - the change event
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({[name]: value});
  }
  /** @function handleBlur
    * Applies the updated state to the firebase database
    */
  handleBlur(event) {
    firebase.database()
    .ref(`${this.props.dataURL}/${event.target.name}`)
    .set(this.state[event.target.name]);
  }
  /** @function render
    * Renders the size component
    */
  render() {
    return (
      <div className="input-group">
        <label>Size</label>
        <div className="dimension-inputs">
          <input type="number" name="width"
            value={this.state.width}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            />
          x
          <input type="number" name="height"
            value={this.state.height}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            />
          pixels
        </div>
        <label htmlFor="scaleToFit">
          <input type="checkbox" name="scaleToFit"
            checked={this.state.scaleToFit}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            />
          Scale to Fit
        </label>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/stage-editor/size.js